import { Loading } from 'element-react'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useMatches, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { useHubSpotChatRefresh } from '../hooks/use-hubspot-chat-refresh'
import * as AppModule from '../v2/Modules/AppModule'
import * as AppSiteModule from '../v2/Modules/AppSiteModule'
import * as ServiceModule from '../v2/Modules/Core/ServiceModule'
import type { StoreType } from '../v2/Types'

export const V2AppRoot: React.FC = () => {
  const { site_name: siteName } = useParams<{ site_name: string }>()
  const dispatch = useDispatch()
  const { loading } = useSelector((store: StoreType) => store.ui.Bootstrap)
  const { site_list } = useSelector((store: StoreType) => store.ui.Service)
  const workspace = useSelector((store: StoreType) => store.app.Workspace)
  const initialize = () => dispatch(AppModule.initialize())
  const siteInitialize = (siteName: string) =>
    dispatch(AppSiteModule.initialize(siteName))
  const updateCurrentSideMenu = (current) =>
    dispatch(AppModule.updateCurrentSideMenu(current))
  const load = (id: number) => dispatch(ServiceModule.load(id))

  const matches = useMatches()
  const current = matches[matches.length - 1]?.handle as {
    value: 'home' | 'lead' | 'cms'
  }

  useEffect(() => {
    if (loading && siteName) {
      siteInitialize(siteName)
    } else if (loading) {
      initialize()
    }

    updateCurrentSideMenu(current?.value)
  }, [])

  useEffect(() => {
    if (!workspace?.id || (site_list && site_list.length)) return
    load(workspace?.id)
  }, [workspace?.id])

  useHubSpotChatRefresh()

  if (loading) {
    return <StyledLoading />
  }

  return (
    <>
      <Helmet>
        {/* TODO: Clarityのタグはblade側に寄せる */}
        <script type="text/javascript">
          {/* {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "mmyk69swqb");
          `} */}
        </script>
      </Helmet>
      <Outlet />
    </>
  )
}

const StyledLoading = styled(Loading)`
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
